import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will create the integration with ELK.`}</p>
    <h2>{`🚀 TASK: Create the ELK Integration`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=connections-elk" target="_blank">🌏 Documentation for the Task: Creating ELK connections</a>
    <p>{`Create the ELK Integration with the following parameters:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`ELK service URL:        from MY_CONFIGURATION.txt
Kibana URL:             from MY_CONFIGURATION.txt
Authentication type:        Token
Token:              from MY_CONFIGURATION.txt

Filter:
{
 "query": {
  "bool": {
   "must": {
    "term" : { "kubernetes.namespace_name" : "robot-shop" }
   }
  }
 }
}


TimeZone:           set to your Timezone    
Kibana port:            443

Mapping:
{ 
"codec": "elk",
"message_field": "message",
"log_entity_types": "kubernetes.container_image_id, kubernetes.host, kubernetes.pod_name, kubernetes.namespace_name",
"instance_id_field": "kubernetes.container_name",
"rolling_time": 10,
"timestamp_field": "@timestamp"
}
`}</code></pre>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`🔎 The parameters can also be found in your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<strong parentName="p">{`2.2 Configure ELK`}</strong>{` `}</p>
    </InlineNotification>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Define`}</inlineCode>{`/`}<inlineCode parentName="p">{`Data and tool connections`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Under `}<inlineCode parentName="p">{`ELK`}</inlineCode>{`, click on `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Connect`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Name it `}<inlineCode parentName="p">{`ELK`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`🔎 Get the data from your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<inlineCode parentName="p">{`2.2 Configure ELK`}</inlineCode>{` `}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`./tools/11_practicum/get_configuration_info.sh > MY_CONFIGURATION.txt
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the fields on the first page:`}</p>
            <img parentName="li" {...{
              "src": "./../images/25_elk.png",
              "alt": "image"
            }}></img>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`ELK service URL:        from MY_CONFIGURATION.txt
Kibana URL:             from MY_CONFIGURATION.txt
Authentication type:        Token
Token:              from MY_CONFIGURATION.txt

Filter:
    {
    "query": {
        "bool": {
            "must": {
                "term" : { "kubernetes.namespace_name" : "robot-shop" }
            }
            }
        }
    }

TimeZone:               set to your Timezone    
Kibana port:            443
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Test connection`}</inlineCode>{`. You should get `}<inlineCode parentName="p">{`Connection successful!`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/26_elk.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the `}<inlineCode parentName="p">{`Field mapping`}</inlineCode>{`:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`{ 
"codec": "elk",
"message_field": "message",
"log_entity_types": "kubernetes.container_image_id, kubernetes.host, kubernetes.pod_name, kubernetes.namespace_name",
"instance_id_field": "kubernetes.container_name",
"rolling_time": 10,
"timestamp_field": "@timestamp"
}
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/27_elk.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Turn On `}<inlineCode parentName="p">{`Data collection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`Live data for continuous AI training and anomaly detection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Done`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Make sure that the Data Collection and Connection Status turn green after a few minutes`}</p>
            <img parentName="li" {...{
              "src": "./../images/28_elk.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      